class BuyButtons extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.els.cartAdd.element, 'click', this.addToCart.bind(this))
    this.observeSubscriptionWidgetLoading()
  }

  // Observe the subscription widget for when it starts adding to cart, then observe for when it finishes loading to open the cart drawer
  observeSubscriptionWidgetLoading () {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target
          if (target.classList.contains('gbbMixCascadeAddToCartBtn--loading')) {
            this.observeSubscriptionWidgetLoadingFinished()

            observer.disconnect()
          }
        }
      })
    })

    observer.observe(this, { attributes: true, subtree: true })
  }

  // Observe the subscription widget for when it finishes adding to cart, then open the cart drawer and start observing for when it starts loading again
  observeSubscriptionWidgetLoadingFinished () {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target
          if (!target.classList.contains('gbbMixCascadeAddToCartBtn--loading')) {
            window.drawers.activeDrawerKey = 'cart'
            observer.disconnect()

            this.observeSubscriptionWidgetLoading()
          }
        }
      })
    })

    observer.observe(this, { attributes: true, subtree: true })
  }

  addToCart (e) {
    e.preventDefault()

    const button = e.target
    if (!button) return

    const form = button.closest('form')
    if (!form) return

    this.addToCartFromForm(form)
  }

  async addToCartFromForm (form) {
    return window.BAO.Cart.addItemFromForm(form)
  }
}

if (!customElements.get('buy-buttons')) {
  customElements.define('buy-buttons', BuyButtons)
}
